import { WRENCH_MODE_SCHEDULE_LOCATIONS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/wrench_mode_schedule_locations_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['wrenchModeScheduleLocationsIndex']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
